import React, { useCallback, useState } from "react";


import { useDictionary } from "hooks";

import CollapsibleSection from "../Internal/CollapsibleSection";
import styles from "./styles.css";
import { changeUpdatedTabsInConfig } from "./utils";

const SimplifiedFormBuilderTabList = ({ config, onTabSelect, onChange, id }) => {
	const [ currentTab, setCurrentTab ] = useState(0);
	const dictionary = useDictionary("simplifiedBuilder.components.TabList");

	const setTab = t => {
		onTabSelect(t);
		setCurrentTab(t);
	};

	const modifyData = updatedList => {
		const previouslySelectedTab = config.extraSettings.sections[currentTab].id;
		const newConfig = changeUpdatedTabsInConfig(config, updatedList);
		const newTabsConfig = newConfig.extraSettings.tabsorder;

		setTab(Math.max(newTabsConfig.indexOf(previouslySelectedTab), 0));
		onChange(newConfig);
	};

	const getStyles = useCallback(tabNumber => {
		let stylesString = "item ";
		if (tabNumber === 0) {
			stylesString += styles.tabListFirstItem + " ";
		}
		stylesString += tabNumber === currentTab ?
      `${styles.tabListItemActive} active`
			: styles.tabListItem;

		return stylesString;
	}, [ currentTab ]);

	return (
		<CollapsibleSection
			title={dictionary.formSections}
			onChangeMasterUpdate={modifyData}
			sections={[ ...config.extraSettings.sections ]}
		>
			<div className={`${styles.tabListBorder} ui fluid vertical menu`} role="tablist" aria-label="Form sections">
				{config.extraSettings.sections.map((tab, t) => (
					<button
						role="tab"
						aria-selected={t === currentTab}
						aria-controls={`${id}.extraSettings.sections["${t}"]`}
						aria-label={(t + 1) + ". " + tab.label}
						className={getStyles(t)}
						key={"tab-list-" + t}
						onClick={() => setTab(t)}
					>
						{(t + 1) + ". " + tab.label}
					</button>
				))}
			</div>
		</CollapsibleSection>
	);
};

export default SimplifiedFormBuilderTabList;
